import React from "react";

// Device codes the command channel can end with, in words a reader can act on.
export const ERROR_MESSAGES = {
	UNKNOWN_METHOD: 'This hub does not offer this command. It has no Zigbee radio, or its firmware predates it.',
	UNSUPPORTED: 'This hub does not offer this command. It has no Zigbee radio, or its firmware predates it.',
	DEVICE_OFFLINE: 'The hub is offline.',
	TIMEOUT: 'The hub did not answer in time.',
};

// Cluster IDs come back as numbers; hex is how every Zigbee spec and sniffer names them.
export function hex(value, width) {
	if (typeof value !== 'number') return String(value);
	return '0x' + value.toString(16).padStart(width || 4, '0');
}

export function Unknown() {
	return <span className={'zb-muted'}>unknown</span>;
}

export function formatValue(value) {
	if (value === undefined || value === null) return null;
	return typeof value === 'object' ? JSON.stringify(value) : String(value);
}

export function errorMessage(err, doing) {
	return ERROR_MESSAGES[err.code] || 'Could not ' + doing + ': ' + err.message;
}
